import React from 'react';
import css from './ErrorScreen.css'

const ErrorScreen = () => {
  return (
    <div className={css.container}>
      <img className={css.errorIcon} src={'../images/starfish/starfish_error.png'}/>
      <p className={css.errorText}>We are having trouble loading your content at this time.</p>
    </div>
  )
}

export default ErrorScreen;
